import { render, staticRenderFns } from "./viewProduct.vue?vue&type=template&id=796d5cc4&scoped=true&"
import script from "./viewProduct.vue?vue&type=script&lang=js&"
export * from "./viewProduct.vue?vue&type=script&lang=js&"
import style0 from "./viewProduct.vue?vue&type=style&index=0&id=796d5cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796d5cc4",
  null
  
)

export default component.exports